module.exports = __webpack_public_path__ + "static/media/portrait_fien2.ea8778d7.jpeg";